import React from 'react';
export function Table({ columns, data, loading, emptyMessage='No records found' }) {
  if (loading) return <div className="flex justify-center py-16"><div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"/></div>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-100">
            {columns.map((c,i) => <th key={i} className="text-left py-3 px-4 text-xs font-semibold text-gray-400 uppercase tracking-wide">{c.header}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.length === 0
            ? <tr><td colSpan={columns.length} className="text-center py-14 text-gray-400 text-sm">{emptyMessage}</td></tr>
            : data.map((row,i) => (
              <tr key={row._id || i} className="border-b border-gray-50 hover:bg-gray-50/60 transition-colors">
                {columns.map((c,j) => <td key={j} className="py-3 px-4">{c.render ? c.render(row) : String(row[c.accessor] ?? '')}</td>)}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}